import useShallowSelector from "./useShallowSelector";

const useCaseOne = () => {
    return useShallowSelector(({case_one}) => case_one);
};

export default useCaseOne;